module.exports = __webpack_public_path__ + "img/logo-lithos-dark.942dcc33.svg";